import { all, fork, put, takeEvery, call, takeLatest } from 'redux-saga/effects';
import { UserActionTypes } from './constants';

import { user, createUser, updateUser, deleteUser } from './api';
import { toast } from 'react-toastify';
/**
 * Login the user
 * @param {*} payload - username and password
 */


function* userDataGetFunction(data) {
    try {
        yield put({
            type: UserActionTypes.USER_DATA_LOADING,
            payload: {},
        });
        const response = yield call(user, data);
        if (response.data.status) {
            yield put({
                type: UserActionTypes.USER_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: UserActionTypes.USER_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: UserActionTypes.USER_DATA_ERROR,
            payload: error,
        });
    }
}

function* userDataCreateFunction(data) {
    try {
        yield put({
            type: UserActionTypes.CREATE_USER_DATA_LOADING,
            payload: {},
        });
        const response = yield call(createUser, data);
        if (response.data.status) {
            yield put({
                type: UserActionTypes.CREATE_USER_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: UserActionTypes.CREATE_USER_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        toast.error(error||'Failed ! Creating User');
        yield put({
            type: UserActionTypes.CREATE_USER_DATA_ERROR,
            payload: error,
        });
    }
}

function* userDataUpdateFunction(payload) {
    try {
        yield put({
            type: UserActionTypes.UPDATE_USER_DATA_LOADING,
        });

        const response = yield call(updateUser, payload);


        if (response && response.data && response.data.status === 'success') {
            yield put({
                type: UserActionTypes.UPDATE_USER_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: UserActionTypes.UPDATE_USER_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error||'Failed ! Updating User');

        yield put({
            type: UserActionTypes.UPDATE_USER_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

function* userDataDeleteFunction(payload) {
    try {
        yield put({
            type: UserActionTypes.DELETE_USER_DATA_LOADING,
        });

        const response = yield call(deleteUser, payload);


        if (response && response.data && response.data.status) {
            yield put({
                type: UserActionTypes.DELETE_USER_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            yield put({
                type: UserActionTypes.DELETE_USER_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        yield put({
            type: UserActionTypes.DELETE_USER_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

export function* watchUserDataGet() {
    yield takeLatest(UserActionTypes.USER_DATA_FIRST, userDataGetFunction);
}
export function* watchUserDataCreate() {
    yield takeEvery(UserActionTypes.CREATE_USER_DATA_FIRST, userDataCreateFunction);
}
export function* watchUserDataUpdate() {
    yield takeLatest(UserActionTypes.UPDATE_USER_DATA_FIRST, userDataUpdateFunction);
}
export function* watchUserDataDelete() {
    yield takeEvery(UserActionTypes.DELETE_USER_DATA_FIRST, userDataDeleteFunction);
}


function* userSaga() {
    yield all([
        fork(watchUserDataGet),
        fork(watchUserDataCreate),
        fork(watchUserDataUpdate),
        fork(watchUserDataDelete),
    ]);
}
export default userSaga;